/* ============================
  Keymax — Quick Buy (V1.3.1 CLEAN)
  - AJAX add to cart
  - Dispatches: cart:update / cart:error
  - Opens native cart drawer
  - Safe init for injected HTML
  - Sync UI on variant change (price/compare/badge/image + qty rules)
============================ */

(() => {
  const SEL = {
    root: "[data-km-qb]",
    form: "form[action*='/cart/add'], form[action*='cart/add'], form",
    note: "[data-km-qb-note]",

    variantSelect: "select[name='id'], [data-km-qb-variant-select]",
    qtyInput: "input[name='quantity'], [data-km-qb-qty]",
    btnBuy: "[data-km-qb-buy], button[type='submit']",

    img: "[data-km-qb-img]",
    priceNow: "[data-km-qb-price-now]",
    priceCompare: "[data-km-qb-price-compare]",
    badge: "[data-km-qb-badge]",

    qtyMinus: "[data-km-qb-qty-minus]",
    qtyPlus: "[data-km-qb-qty-plus]",
  };

  function setNote(root, msg, isHTML) {
    const note = root.querySelector(SEL.note);
    if (!note) return;
    if (isHTML) note.innerHTML = msg || "";
    else note.textContent = msg || "";
  }

  function clamp(n, min, max) {
    const nn = Number.isFinite(n) ? n : min;
    if (max != null) return Math.max(min, Math.min(max, nn));
    return Math.max(min, nn);
  }

  function readOptionData(opt) {
    if (!opt) return null;

    const available =
      opt.dataset.available === "true" ||
      opt.dataset.available === "1" ||
      opt.dataset.available === "available";

    const price = opt.dataset.price || "";
    const compare = opt.dataset.compare || "";
    const priceCents = opt.dataset.priceCents ? Number(opt.dataset.priceCents) : null;
    const compareCents = opt.dataset.compareCents ? Number(opt.dataset.compareCents) : null;
    const img = opt.dataset.img || "";

    const min = opt.dataset.min ? parseInt(opt.dataset.min, 10) : 1;
    const step = opt.dataset.step ? parseInt(opt.dataset.step, 10) : 1;
    const max = opt.dataset.max ? parseInt(opt.dataset.max, 10) : null;

    return { available, price, compare, priceCents, compareCents, img, min, step, max };
  }

  function calcDiscountPct(priceCents, compareCents) {
    if (!Number.isFinite(priceCents) || !Number.isFinite(compareCents)) return null;
    if (compareCents <= 0 || compareCents <= priceCents) return null;
    return Math.round(((compareCents - priceCents) / compareCents) * 100);
  }

  function syncUIFromVariant(root) {
    const select = root.querySelector(SEL.variantSelect);
    const qty = root.querySelector(SEL.qtyInput);
    const btn = root.querySelector(SEL.btnBuy);

    // Produto 1 variante: só garante qty ok
    if (!select) {
      if (qty) {
        const min = parseInt(qty.getAttribute("min") || "1", 10) || 1;
        const step = parseInt(qty.getAttribute("step") || "1", 10) || 1;
        const max = qty.hasAttribute("max") ? parseInt(qty.getAttribute("max"), 10) : null;

        let cur = parseInt(qty.value || String(min), 10);
        if (!Number.isFinite(cur)) cur = min;

        if ((cur - min) % step !== 0) cur = min + Math.floor((cur - min) / step) * step;

        qty.min = String(min);
        qty.step = String(step);
        if (max != null && Number.isFinite(max)) qty.max = String(max);
        else qty.removeAttribute("max");

        qty.value = String(clamp(cur, min, max));
      }
      return;
    }

    const opt = select.selectedOptions && select.selectedOptions[0] ? select.selectedOptions[0] : null;
    const data = readOptionData(opt);
    if (!data) return;

    // Preços / compare / badge
    const elNow = root.querySelector(SEL.priceNow);
    const elCompare = root.querySelector(SEL.priceCompare);
    const elBadge = root.querySelector(SEL.badge);

    if (elNow && data.price) elNow.textContent = data.price;

    const hasCompare =
      data.compareCents != null &&
      data.priceCents != null &&
      data.compareCents > data.priceCents;

    if (elCompare) {
      if (hasCompare && data.compare) {
        elCompare.textContent = data.compare;
        elCompare.hidden = false;
      } else {
        elCompare.hidden = true;
      }
    }

    if (elBadge) {
      if (hasCompare) {
        const pct = calcDiscountPct(data.priceCents, data.compareCents);
        if (pct != null) {
          elBadge.textContent = `-${pct}%`;
          elBadge.hidden = false;
        } else {
          elBadge.hidden = true;
        }
      } else {
        elBadge.hidden = true;
      }
    }

    // Imagem
    const img = root.querySelector(SEL.img);
    if (img && data.img) {
      img.src = data.img;
      img.style.display = "";
    }

    // Qty rules
    if (qty) {
      const min = Number.isFinite(data.min) ? data.min : 1;
      const step = Number.isFinite(data.step) ? data.step : 1;
      const max = Number.isFinite(data.max) ? data.max : null;

      qty.min = String(min);
      qty.step = String(step);
      if (max != null) qty.max = String(max);
      else qty.removeAttribute("max");

      let cur = parseInt(qty.value || String(min), 10);
      if (!Number.isFinite(cur)) cur = min;

      if ((cur - min) % step !== 0) cur = min + Math.floor((cur - min) / step) * step;

      qty.value = String(clamp(cur, min, max));
    }

    // Disponibilidade
    if (btn) btn.disabled = !data.available;
  }

  function initQtyStepper(root) {
    const input = root.querySelector(SEL.qtyInput);
    if (!input) return;

    if (root.__kmQtyBound) return;
    root.__kmQtyBound = true;

    function readConstraints() {
      const min = parseInt(input.getAttribute("min") || "1", 10) || 1;
      const step = parseInt(input.getAttribute("step") || "1", 10) || 1;
      const max = input.hasAttribute("max") ? parseInt(input.getAttribute("max"), 10) : null;
      return { min, step, max };
    }

    function snapAndSet(next) {
      const { min, step, max } = readConstraints();
      let v = parseInt(next, 10);
      if (!Number.isFinite(v)) v = min;

      if ((v - min) % step !== 0) v = min + Math.floor((v - min) / step) * step;

      v = clamp(v, min, max);
      input.value = String(v);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    root.addEventListener("click", (e) => {
      const minus = e.target.closest(SEL.qtyMinus);
      const plus = e.target.closest(SEL.qtyPlus);
      if (!minus && !plus) return;

      e.preventDefault();
      const { min, step } = readConstraints();
      const cur = parseInt(input.value || String(min), 10) || min;

      snapAndSet(plus ? cur + step : cur - step);
    });

    input.addEventListener("blur", () => {
      const { min } = readConstraints();
      snapAndSet(input.value || String(min));
    });
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const base =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    const res = await fetch(`${base}cart/add.js`, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
    });

    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg = json?.description || json?.message || "Erro ao adicionar ao carrinho.";
      throw new Error(msg);
    }
    return json;
  }

  async function fetchCart() {
    const base =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    const res = await fetch(`${base}cart.js`, { headers: { Accept: "application/json" } });
    return await res.json();
  }

  function dispatchCartUpdate({ cart, variantId }) {
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: "km-quick-buy",
          data: {
            source: "km-quick-buy",
            didError: false,
            itemCount: cart?.item_count,
            variantId: String(variantId || ""),
          },
        },
      })
    );
  }

  function dispatchCartError(message) {
    document.dispatchEvent(
      new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          sourceId: "km-quick-buy",
          data: { message: message || "Erro", errors: message || "" },
        },
      })
    );
  }

  function openCartDrawer() {
    let drawer =
      document.querySelector("cart-drawer-component") ||
      document.querySelector("cart-drawer") ||
      document.querySelector("#CartDrawer") ||
      document.querySelector("[data-cart-drawer]");

    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return true;
    }

    if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === "function") {
      window.theme.cartDrawer.open();
      return true;
    }

    const cartBtn =
      document.querySelector("[data-header-cart]") ||
      document.querySelector("a[href*='/cart']") ||
      document.querySelector("[aria-controls='CartDrawer']");

    if (cartBtn) {
      cartBtn.click();
      return true;
    }

    return false;
  }

  function initOne(root) {
    if (!root || root.__kmQB) return;
    root.__kmQB = true;

    initQtyStepper(root);
    syncUIFromVariant(root);

    const select = root.querySelector(SEL.variantSelect);
    if (select && !select.__kmVarBound) {
      select.__kmVarBound = true;
      select.addEventListener("change", () => syncUIFromVariant(root));
    }

    // Se for modo nativo (PDP blocks), não intercepta submit
    if (root.hasAttribute("data-km-qb-native")) return;

    const form = root.querySelector(SEL.form);
    if (!form) return;

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      setNote(root, "Adicionando...");

      try {
        const variantId =
          form.querySelector("select[name='id']")?.value ||
          form.querySelector("[name='id']")?.value;

        await addToCart(form);

        const cart = await fetchCart();
        dispatchCartUpdate({ cart, variantId });

        openCartDrawer();
        setNote(root, '<span style="display:inline-flex;align-items:center;gap:6px;color:#16a34a;"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.5" stroke="currentColor" stroke-width="1"/><path d="M5 8l2 2 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Adicionado ao carrinho</span>', true);
      } catch (err) {
        const msg = err?.message || "Erro ao adicionar.";
        setNote(root, msg);
        dispatchCartError(msg);
      }
    });
  }

  function initWithin(container) {
    const roots = container.querySelectorAll ? container.querySelectorAll(SEL.root) : [];
    roots.forEach(initOne);
  }

  // expose global
  window.KMQuickBuy = window.KMQuickBuy || {};
  window.KMQuickBuy.init = (container) => {
    if (!container) return;
    if (container.matches && container.matches(SEL.root)) initOne(container);
    initWithin(container);
  };

  document.addEventListener("DOMContentLoaded", () => window.KMQuickBuy.init(document));
  document.addEventListener("shopify:section:load", (e) => window.KMQuickBuy.init(e.target));
  document.addEventListener("km:quickbuy:mount", (e) => window.KMQuickBuy.init(e.detail?.root || document));
})();
